import { Type } from "@sinclair/typebox";
import { Device } from "./device";
import { MessageContent } from "./messageContent";
import { Recipient } from "./recipient";
import { Nullable } from "../../../utils/typeboxTypes";
export const BasePresence = Type.Object({
    /**
     * The date and time of when the presence was created.
     */
    created_at: Type.String(),
    /**
     * The device the presence was created on.
     */
    device: Type.Optional(Nullable(Device)),
}, {
    title: "BasePresence",
});
export const PresenceTyping = Type.Composite([
    BasePresence,
    Type.Object({
        type: Type.Literal("typing"),
        recipient: Recipient,
        content: Type.Optional(MessageContent),
        lastMessageId: Type.Optional(Type.String()),
    }, {
        title: "PresenceTyping",
    }),
]);
export const PresenceJoined = Type.Composite([
    BasePresence,
    Type.Object({
        type: Type.Literal("joined"),
        recipient: Recipient,
    }, {
        title: "PresenceJoined",
    }),
]);
export const PresenceExited = Type.Composite([
    BasePresence,
    Type.Object({
        type: Type.Literal("exited"),
        recipient: Recipient,
        reason: Type.String(),
    }, {
        title: "PresenceExited",
    }),
]);
export const PresenceIdle = Type.Composite([
    BasePresence,
    Type.Object({
        type: Type.Literal("idle"),
        recipient: Recipient,
    }, {
        title: "PresenceIdle",
    }),
]);
export const Presence = Type.Union([PresenceTyping, PresenceJoined, PresenceExited, PresenceIdle]);
